<template>
  <div class="page-container">
    <h1>在线人数</h1>
    <div class="user-options clearfix">
      <div class="bo">用户:</div>
      <span>语言：</span>
      <el-select style="width: 160px" v-model="userLang" placeholder>
        <el-option
          v-for="(item, itemIndex) in userLangList"
          v-bind:key="itemIndex + 199"
          :label="item == '' ? 'null' : ''"
          :value="item"
        ></el-option>
      </el-select>
      <span>国家：</span>
      <el-select style="width: 160px" v-model="userCountry" placeholder>
        <el-option
          v-for="(item, itemIndex) in userCountryList"
          v-bind:key="itemIndex + 199"
          :label="item == '' ? 'null' : ''"
          :value="item"
        ></el-option>
      </el-select>
      <span>渠道：</span>
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex + 199"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="user-options clearfix">
      <div class="bo">主播:</div>
      <span>语言：</span>
      <el-select style="width: 160px" v-model="hostLang" placeholder>
        <el-option
          v-for="(item, itemIndex) in hostLangList"
          v-bind:key="itemIndex + 199"
          :label="item == '' ? 'null' : ''"
          :value="item"
        ></el-option>
      </el-select>
      <span>国家：</span>
      <el-select style="width: 160px" v-model="hostCountry" placeholder>
        <el-option
          v-for="(item, itemIndex) in hostCountryList"
          v-bind:key="itemIndex + 199"
          :label="item == '' ? 'null' : ''"
          :value="item"
        ></el-option>
      </el-select>
      <span>渠道：</span>
      <el-select style="width: 160px" v-model="hostchannel" placeholder>
        <el-option
          v-for="(item, itemIndex) in hostchannels"
          v-bind:key="itemIndex + 199"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <span>主播等级：</span>
      <el-select style="width: 160px" v-model="hostLevel" placeholder>
        <el-option
          v-for="(item, itemIndex) in hostLevels"
          v-bind:key="itemIndex + 199"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <span>时间：</span>
      <el-date-picker
        v-model="dateValue"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="get_lists">查询</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomLine :options="lineOptions" class="line"></CustomLine>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLine from '../../components/CustomLine'
import { datainfor } from '@/utils/formdata.js'
export default {
  name: 'UserOnlinePage',
  components: {
    CustomLine,
  },
  data() {
    return {
      lineOptions: {
        title: '在线人数',
        legend: [
          '主播忙碌人数',
          '主播通话人数',
          '主播在线人数',
          '用户通话人数',
          '用户在线人数',
          '用户在房间人数',
          '活跃房间数',
          '用户付费数',
          '金币足够人数',
          '一张匹配卡人数',
          '两张匹配卡人数',
          '三张匹配卡人数',
          '超过三张匹配卡人数',
          '主播等级L0',
          '主播等级L1',
          '主播等级L2',
          '主播等级L3',
        ],
        xAxis: {
          name: 'UTC时间',
          type: 'category',
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          name: '人数',
          type: 'value',
        },
        series: [
          {
            name: '主播忙碌人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '主播通话人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '主播在线人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '用户通话人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '用户在线人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '用户在房间人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '活跃房间数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '用户付费数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '金币足够人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '一张匹配卡人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '两张匹配卡人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '三张匹配卡人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '超过三张匹配卡人数',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '主播等级L0',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '主播等级L1',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '主播等级L2',
            type: 'line',
            smooth: true,
            data: [],
          },
          {
            name: '主播等级L3',
            type: 'line',
            smooth: true,
            data: [],
          },
        ],
      },
      tableList: [],
      loading: false,

      curChannel: {
        selectValue: 'all',
        content: '',
      },
      channels: this.$store.state.channels,
      userLang: 'all',
      userLangList: [],
      userCountry: '',
      userCountryList: [],
      hostLang: '',
      hostLangList: [],
      hostCountry: '',
      hostCountryList: [],
      hostchannel: 'all',
      hostchannels: [
        {
          label: 'allTikko',
          value: 'all_tikko',
        },
        {
          label: 'allHotchat',
          value: 'all_hotchat',
        },
        {
          label: 'all',
          value: 'all',
        },
        {
          label: 'googleplay_kissboy',
          value: 'googleplay_kissboy',
        },
        {
          label: 'appstore_kissboy',
          value: 'appstore_kissboy',
        },
        {
          label: 'appstore_qboy',
          value: 'appstore_qboy',
        },
      ],
      hostLevel: 'all',
      hostLevels: [
        {
          label: 'null',
          value: '',
        },
        {
          label: 'all',
          value: 'all',
        },

        {
          label: 'L0',
          value: 'L0',
        },
        {
          label: 'L1',
          value: 'L1',
        },
        {
          label: 'L2',
          value: 'L2',
        },
        {
          label: 'L3',
          value: 'L3',
        },
      ],
      dateValue: datainfor(1),
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate())
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        },
      },
    }
  },
  beforeCreate() {},
  created() {
    // this.getList()
    this.get_list()
    this.get_lists()
    this.channels = [
      {
        label: 'allTikko',
        value: 'all_tikko',
      },
      {
        label: 'allHotchat',
        value: 'all_hotchat',
      },
      ...this.channels,
    ]
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    },
  },
  watch: {
    userLang: {
      handler(newName) {
        if (newName !== '') {
          this.userCountry = ''
        }
      },
      deep: true,
    },
    userCountry: {
      handler(newName) {
        if (newName !== '') {
          this.userLang = ''
        }
      },
      deep: true,
    },
    hostLang: {
      handler(newName) {
        if (newName !== '') {
          this.hostCountry = ''
          this.hostLevel = ''
        }
      },
      deep: true,
    },
    hostCountry: {
      handler(newName) {
        if (newName !== '') {
          this.hostLang = ''
          this.hostLevel = ''
        }
      },
      deep: true,
    },
    hostLevel: {
      handler(newName) {
        if (newName !== '') {
          this.hostCountry = ''
          this.hostLang = ''
        }
      },
      deep: true,
    },
  },
  methods: {
    async get_list() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.actors_config,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res !== null) {
        this.userLangList = res.data.userLangList
        this.userCountryList = res.data.userCountryList
        this.hostLangList = res.data.hostLangList
        this.hostCountryList = res.data.hostCountryList
        this.hostCountryList.unshift('')
        this.userCountryList.unshift('')
        this.userLangList.unshift('')
        this.hostLangList.unshift('')
      }
    },

    async get_lists() {
      if (this.userLang == '' && this.userCountry == '') {
        return this.$message('用户语言和国家不能同时选空')
      }
      if (
        this.hostCountry == '' &&
        this.hostLang == '' &&
        this.hostLevel == ''
      ) {
        return this.$message('主播语言和国家和等级不能同时选空')
      }
      this.loading = true
      const { data: res } = await this.$axios({
        method: 'post',
        url:
          this.$store.getters.path.online_actors +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        data: {
          start: this.dateValue,
          userData: {
            channel: this.curChannel.selectValue,
            lang: this.userLang,
            countryCode: this.userCountry,
          },
          hostData: {
            channel: this.hostchannel,
            lang: this.hostLang,
            countryCode: this.hostCountry,
            hostLevel: this.hostLevel,
          },
        },
      })
      if (res !== null) {
        this.loading = false
        this.lineOptionBuild(res.data.list)
      }
    },
    // 折线图配置
    lineOptionBuild(data) {
      this.lineOptions.xAxis.data = []
      for (let i = 0; i < this.lineOptions.series.length; i++) {
        this.lineOptions.series[i].data = []
      }
      for (let j in data) {
        if (data.hasOwnProperty(j)) {
          this.lineOptions.xAxis.data.push(this.format(data[j].ctime))
          this.lineOptions.series[0].data.push(data[j].hostBusyCount)
          this.lineOptions.series[1].data.push(data[j].hostCallingCount)
          this.lineOptions.series[2].data.push(data[j].hostOnlineCount)
          this.lineOptions.series[3].data.push(data[j].userCallingCount)
          this.lineOptions.series[4].data.push(data[j].userOnlineCount)
          this.lineOptions.series[5].data.push(data[j].userInRoomCount)
          this.lineOptions.series[6].data.push(data[j].hostInRoomCount)
          this.lineOptions.series[7].data.push(data[j].payCount)
          this.lineOptions.series[8].data.push(data[j].goldEnoughCount)
          this.lineOptions.series[9].data.push(data[j].oneMatchCardCount)
          this.lineOptions.series[10].data.push(data[j].twoMatchCardCount)
          this.lineOptions.series[11].data.push(data[j].threeMatchCardCount)
          this.lineOptions.series[12].data.push(
            data[j].greatThreeMatchCardCount
          )
          this.lineOptions.series[13].data.push(data[j].zeroHostLevelCount)
          this.lineOptions.series[14].data.push(data[j].oneHostLevelCount)
          this.lineOptions.series[15].data.push(data[j].twoHostLevelCount)
          this.lineOptions.series[16].data.push(data[j].threeHostLevelCount)
        }
      }
    },
    format(shijianchuo) {
      let date = new Date((shijianchuo - 8 * 60 * 60) * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // let Y = date.getFullYear() + "-";
      // let M =
      //   (date.getMonth() + 1 < 10
      //     ? "0" + (date.getMonth() + 1)
      //     : date.getMonth() + 1) + "-";
      // let D =
      //   (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h = date.getHours() + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return h + m + s
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .bo {
    margin: 0 0 15px;
    font-size: 25px;
    font-weight: bold;
  }

  .clearfix {
    > span {
      margin: 0 10px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
